import styled from 'styled-components'
import Icon from './Icon'

const LockIcon = styled(Icon).attrs({
  type: 'lock',
})``

export default LockIcon
